import { SelectedCompany } from 'common/types';

export const companyNeedsManagerReview = (company: SelectedCompany) => {
  return !!company?.needsManagerReview;
};

export const getOmnipresentTenantId = () =>
  process.env.VITE_OMNIPRESENT_TENANT_ID;
